export default __webpack_public_path__ + "static/media/ico_search.667a3682.svg";